export const handleChangeDataWithdrawWalletPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_WITHDRAW', name, value
});